import * as React from 'react';
import * as ReactDOM from 'react-dom';

import {Dropdown, DropdownProps} from 'semantic-ui-react';

interface Item {
	text: any;
	value?: string;
}

interface Props {
	onChange: (value: string) => void;
	choices: Item[];
	value?: string;
	color: string;
	complete: boolean;
	rerender: any;
}

interface State {}

declare const MathJax: any;

export default class ChoicesComponent extends React.Component<Props, State> {

	componentDidMount () {
		this.typeset();
	}

	componentDidUpdate () {
		this.typeset();
	}

	render () {
		return <span> <Dropdown className={'choices ' + this.props.color} value={this.props.value} style={{color: this.props.value === undefined ? 'violet' : this.props.color}} inline icon={null} placeholder='?' options={this.props.choices.map((choice, index) => { return {key: index, text: choice.text, value: choice.value, selected: false, active: false}; })} onClick={() => this.props.rerender()} onChange={(event: any, data: DropdownProps) => this.props.onChange(data.value as string)} /> </span>;
	}

	private typeset () {
		try {
			MathJax.Hub.Queue(['Typeset', MathJax.Hub, ReactDOM.findDOMNode(this)]);

		} catch (e) {
			return; // Catch MathJax is not defined exception
		}
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/exercises/ChoicesComponent.tsx